import React, { FC, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Menu,
  MenuItem,
  SwipeableDrawer,
  Typography,
} from '@mui/material';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import JsonView from '@uiw/react-json-view';
import BugReportIcon from '@mui/icons-material/BugReport';
import EventLogsWrapper, {
  DrawerHeader,
  jsonViewTheme,
} from './EventLogs.styled';
import { EventLogsEAnchor, IEventLogsProps, IJsonEvents } from './@types/EventLogs';
import { EVENT_LOGS_ANCHOR_LOCAL_STORAGE_KEY } from './EventLogs.values';

const EventLogsComponent: FC<IEventLogsProps> = ({ eventList, open = false, onClose, onOpen }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openOptions = Boolean(anchorEl);
  const [anchor, setAnchor] = useState<EventLogsEAnchor>(
    (window.localStorage.getItem(EVENT_LOGS_ANCHOR_LOCAL_STORAGE_KEY) as EventLogsEAnchor) ||
      EventLogsEAnchor.RIGHT,
  );
  const [dateToFilter, setDateToFilter] = useState<Date | undefined>(undefined);

  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: true,
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleOnClose = (): void => {
    if (onClose) {
      onClose();
    }
  };

  const handleOnOpen = (): void => {
    if (onOpen) {
      onOpen();
    }
  };

  const handleSelectedOption = (opt: EventLogsEAnchor): void => {
    setAnchor(opt);
    setAnchorEl(null);
    handleOnClose();
    window.localStorage.setItem(EVENT_LOGS_ANCHOR_LOCAL_STORAGE_KEY, opt);
    setTimeout(() => {
      handleOnOpen();
    }, 200);
  };

  const handleCloseOptions = (): void => {
    setAnchorEl(null);
  };

  const handleOnClean = (): void => {
    setDateToFilter(new Date());
  };

  const eventLogMapJson = useMemo(() => {
    const jsonEvents: IJsonEvents = {};
    if (eventList?.length) {
      [...eventList]
        .reverse()
        .filter((event) => (!dateToFilter ? true : event?.date >= dateToFilter))
        .map((event, index) => {
          const number = eventList.length - index;
          jsonEvents[`${event?.tag}::${number}`] = { ...event };
          return event;
        });
    }
    return jsonEvents;
  }, [eventList, dateToFilter]);

  useMemo(() => {
    setState({ ...state, [anchor]: open });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <EventLogsWrapper data-testid="EventLogsComponent" className="EventLogsComponent">
      <SwipeableDrawer
        data-testid="EventLogsComponent_SwipeableDrawer"
        anchor={anchor}
        open={state[anchor]}
        onClose={handleOnClose}
        onOpen={handleOnOpen}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: 4,
            height: '50vh',
          }}
        >
          <DrawerHeader>
            <BugReportIcon />
            <Typography variant="h5" gutterBottom>
              Events Logs
            </Typography>
            <Button
              id="basic-button"
              aria-controls={openOptions ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openOptions ? 'true' : undefined}
              onClick={handleClick}
            >
              <SettingsIcon />
            </Button>
            <Button
              id="basic-button"
              aria-controls={openOptions ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openOptions ? 'true' : undefined}
              onClick={handleOnClean}
            >
              <DeleteSweepIcon />
            </Button>
            <Button
              id="basic-button"
              aria-controls={openOptions ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openOptions ? 'true' : undefined}
              onClick={handleOnClose}
            >
              <CloseIcon className="btnCloseIcon" />
            </Button>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openOptions}
              onClose={handleCloseOptions}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => handleSelectedOption(EventLogsEAnchor.LEFT)}>Left</MenuItem>
              <MenuItem onClick={() => handleSelectedOption(EventLogsEAnchor.RIGHT)}>Right</MenuItem>
              <MenuItem onClick={() => handleSelectedOption(EventLogsEAnchor.TOP)}>Top</MenuItem>
              <MenuItem onClick={() => handleSelectedOption(EventLogsEAnchor.BOTTOM)}>Bot</MenuItem>
              <MenuItem onClick={() => handleSelectedOption(EventLogsEAnchor.BOTTOM)}>Bot</MenuItem>
            </Menu>
          </DrawerHeader>
          <Divider />
          <Box>
            <JsonView
              // collapsed
              value={eventLogMapJson}
              objectSortKeys={false}
              // displayObjectSize={false}
              displayDataTypes={false}
              // indentWidth={0}
              // objectSortKeys={false}
              // shortenTextAfterLength={10}
              keyName=""
              style={jsonViewTheme}
            />
          </Box>
        </Box>
      </SwipeableDrawer>
    </EventLogsWrapper>
  );
};

export default EventLogsComponent;
export type { IEventLogsProps };
